import { type RouterOutputs, api } from "@/components/TRPCProvider"
import type { UseTRPCQueryOptions } from "@trpc/react-query/shared"

export function useMe(opts?: UseTRPCQueryOptions<RouterOutputs["user"]["me"], RouterOutputs["user"]["me"], unknown>) {
  return api.user.me.useQuery(undefined, { staleTime: Number.POSITIVE_INFINITY, gcTime: Number.POSITIVE_INFINITY, ...opts })
}
